require('@fancyapps/fancybox');
window.$ = window.jQuery = require('jquery');

$(document).ready(function() {
  var menu = $('.nav-desktop');
  var origOffsetY = menu.offset().top;
  document.onscroll = function() {
    if ($(window).scrollTop() > origOffsetY) {
      menu.addClass('fixed');
      $('main').addClass('navi-padding');
    } else {
      menu.removeClass('fixed');
      $('main').removeClass('navi-padding');
    }
  };

  $('button[data-toggle="collapse"]').click(function(e) {
    if ($(this).hasClass('collapsed do-unblur')) {
      $(this).blur();
    }
    var toggleText = $(this).data('toggle-text');
    if (toggleText == undefined) {
      return;
    }
    var currentText = $(this).text();
    $(this).text(toggleText);
    $(this).data('toggle-text', currentText);
  });

  $('a[href^="#"]').on('click', function(e) {
    e.preventDefault();
    $('.navbar-collapse').collapse('hide');
    var target = this.hash;
    var $target = $(target);
    var navOffset = 205;
    if (['xs','sm'].includes(getViewport())) {
      navOffset = 120;
    }
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top - navOffset
    }, 900, 'swing');
  });

  $('.show-more, .show-less').click(function() {
    var target = $(this).data('target');
    $(this).blur();
    $('button[data-target=' + target + ']').toggle();
    $('#' + target).slideToggle();
  });

  $(".privacy-iframe").privacyIframe({
    bgOdd: '#c7ebfc',
    bgEven: '#e3f5fd'
  });

  window.cookieconsent.initialise({
    "palette": {
      "popup": {
        "background": "#666",
        "text": "#fff"
      },
      "button": {
        "background": "#e30613",
        "text": "#fff"
      }
    },
    "position": "bottom-right",
    "showLink": true,
    "content": {
      "message": "Unsere Webseite verwendet Cookies. Mit der Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies verwenden.",
      "dismiss": "Akzeptieren",
      "link": "Datenschutzerklärung",
      "href": path_www + "datenschutz"
    }
  });

  $('.submit-contact-form').not('.submitted').click(function() {
    let $button = $(this);

    var $form = $('#contact-form');
    if ($form.hasClass('submitted')) {
      return;
    }

    var data = $form.serialize();
    $form.addClass('submitted');

    $.ajax({
      type: "POST",
      url: path_www + 'service/contact',
      data: data,
      success: function() {
        $form.slideUp(function() {
          $('<div class="alert alert-success mb-5" style="display:none;">Vielen Dank für Ihre Nachricht an uns!<br/>Wir kümmern uns schnellstmöglich um Ihre Anfrage.</div>').insertAfter($form).slideDown();
        });
      },
      error: function(xhr) {
        var title = 'Beim Senden der Daten ist ein Fehler aufgetreten.';
        if (xhr.responseText) {
          try {
            var response = JSON.parse(xhr.responseText);
            if (response.error === 'missing-fields') {
              title = 'Es wurden nicht alle benötigten Felder ausgefüllt.';
            } else if (response.error === 'mail-failed') {
              title = 'Mailversand fehlgeschlagen.';
            }
          } catch(ignored) {}
        }
        $button.tooltip({
          placement: 'bottom',
          trigger: 'manual',
          template: '<div class="tooltip danger" role="tooltip"><div class="arrow"></div><div class="tooltip-inner bg-danger"></div></div>',
          title: title
        })
        .tooltip('show')
        .on('shown.bs.tooltip', function() {
          let tooltip = $(this);
          setTimeout(function() {
            $form.removeClass('submitted');
            tooltip.tooltip('dispose');
          }, 5000)
        });
      }
    });
  });
});

function getViewport() {
  const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
  if (width < 576) return 'xs'
  if (width < 768) return 'sm'
  if (width < 992) return 'md'
  if (width < 1200) return 'lg'
  return 'xl'
}